import React from 'react';
import routes from '@catalogo/shell-web/src/routes';
import { matchPath } from 'react-router-dom';

export const withPageType = Component => {
  const Wrapper = props => {
    const { pathname } = props.location || {};
    const type = getPageType(pathname);

    return <Component {...props} pageType={type} />;
  };
  return Wrapper;
};

export const getPageType = pathname => {
  const { type } = routes.find(route => matchPath(pathname, route)) || {};
  return type;
};
